"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesPostAsyncSlice = void 0;
const get_1 = require("./get.js");
const name_1 = require("./name.js");
const _api_1 = require("../../api/index.js");
const sonar_analytics_1 = require("@sonar-software/sonar-analytics");
const xuder_1 = require("@sonar-software/xuder");
exports.coreInitiativesPostAsyncSlice = (0, xuder_1.createPostAsyncSlice)({
    additionalRequestSteps: [
        {
            actionHandler: (0, sonar_analytics_1.createLogSaga)(sonar_analytics_1.AMPLITUDE_EVENT.INITIATIVE_CREATED, (action) => ({
                craetedFrom: action.data.source
            })),
            type: xuder_1.SagaYieldType.Every
        }
    ],
    httpSagaOptions: {
        successActionCreators: [get_1.coreInitiativesGetAsyncSlice.asyncActionCreators.repeatGetCoreInitiatives]
    },
    name: name_1.CoreInitiativesName,
    receive: true,
    request: true,
    requestHandler: _api_1.postInitiative,
    yieldType: xuder_1.SagaYieldType.Every
});
//# sourceMappingURL=post.js.map